const Language = {
  English: 'en',
  Japanese: 'ja',
} as const
type Language = typeof Language[keyof typeof Language]
export default Language
